export const DUPLICATE_RANGE_TO_NEW_COMPOSITION_EVENT = "duplicateRangeToNewComposition";

export interface DuplicateRangeToNewCompositionDetail {
    startSec: number;
    endSec: number;
    source?: string;
}

export function dispatchDuplicateRangeToNewComposition(detail: DuplicateRangeToNewCompositionDetail) {
    try {
        window.dispatchEvent(
            new CustomEvent<DuplicateRangeToNewCompositionDetail>(
                DUPLICATE_RANGE_TO_NEW_COMPOSITION_EVENT,
                { detail }
            )
        );
    } catch (error) {
        console.error("[duplicateRangeToNewCompositionEvent] Failed to dispatch", error);
    }
}
